jQuery(function ($) {
    var $toggle = $('#menu-toggle');
    var $nav = $('#primary-navigation');

    if (!$toggle.length || !$nav.length) return;

    function syncBodyMenuOpen() {
        var $body = $('body');

        var mobileOpen =
            $toggle.hasClass('show') ||
            $nav.hasClass('show');

        var dropdownOpen =
            $nav.find('.menu-item-has-children.is-open').length > 0;

        $body.toggleClass('menu-open', mobileOpen || dropdownOpen);
    }

    function openMenu() {
        $toggle
            .addClass('show')
            .attr('aria-expanded', 'true');

        $nav.addClass('show');

        syncBodyMenuOpen();
    }

    function closeMenu() {
        $toggle
            .removeClass('show')
            .attr('aria-expanded', 'false');

        $nav.removeClass('show');

        syncBodyMenuOpen();
    }

    function toggleMenu() {
        var isOpen = $toggle.hasClass('show');
        isOpen ? closeMenu() : openMenu();
    }

    // Toggle on button click
    $toggle.on('click', function (e) {
        e.preventDefault();
        toggleMenu();
    });

    // Close on ESC (keyboard accessibility)
    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' && $toggle.hasClass('show')) {
            closeMenu();
            $toggle.trigger('focus');
        }
    });

    // Close when clicking outside the nav + toggle
    $(document).on('click', function (e) {
        if (!$toggle.hasClass('show')) return;

        if (
            !$nav.is(e.target) &&
            $nav.has(e.target).length === 0 &&
            !$toggle.is(e.target) &&
            $toggle.has(e.target).length === 0
        ) {
            closeMenu();
        }
    });

    // Initialize ARIA state
    $toggle.attr('aria-expanded', 'false');

    // Ensure initial state is consistent
    syncBodyMenuOpen();
});
